import { TextField } from 'braid-design-system';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { parseLabel } from '../parseLabel.tsx';
import type { FormValues, NumberFormFields } from '../types.ts';
import { nonEmptyString } from '../validation.ts';

interface NumberFieldProps {
  element: NumberFormFields;
}

export const NumberField = ({ element }: NumberFieldProps) => {
  const { setValue } = useFormContext<FormValues>();
  const label = useMemo(
    () => parseLabel(element.id, element.label, element.labelLinks),
    [element.id, element.label, element.labelLinks],
  );
  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={{
        required: element.required ? 'This field is required' : false,
        validate: element.required
          ? {
              nonEmpty: nonEmptyString('Field cannot be empty'),
              isNumber: (value: string) => {
                const numberValue = parseFloat(value);
                return !isNaN(numberValue) && isFinite(numberValue)
                  ? true
                  : 'Please provide a valid number.';
              },
            }
          : undefined,
      }}
      render={({ field, fieldState }) => (
        <TextField
          label={label}
          placeholder={element.placeholder}
          secondaryLabel={element.secondaryLabel}
          onChange={field.onChange}
          type="number"
          value={field.value}
          tone={fieldState.invalid ? 'critical' : undefined}
          message={fieldState.error?.message}
          onClear={() => setValue(element.id, '')}
        />
      )}
    />
  );
};
